import React, { useRef, useState, useEffect } from 'react';
import './message.css'
import { Button, Overlay, Tooltip, } from 'react-bootstrap';
import { saveDocxText, saveDocxbyCopied, saveDocxbyHTML } from "./save.jsx";

import ReactMarkdown from 'react-markdown';

function MessageSummarize({ user, timestamp, message, saveRequested, onSaved }) {
    const markdownRef = useRef(null);
    const [isCopied, setIsCopied] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const buttonCopyRef = useRef(null);
    
    useEffect(() => {
        if (saveRequested) {
            // 在这里执行保存操作
            saveDocxbyHTML("summarize", markdownRef.current.innerHTML);
        
            // 保存操作完成后，调用 onSaved 回调以将状态重置为 false
            if (onSaved) {
                onSaved();
            }
        }
    }, [saveRequested, onSaved]);

    const handleCopy = (isTooltip=true) => {
        const range = document.createRange();
        range.selectNode(markdownRef.current);
      
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      
        const renderedHTML = markdownRef.current.innerHTML;
        const container = document.createElement("div");
        container.innerHTML = renderedHTML;
      
        const shadow = document.createElement("div");
        shadow.appendChild(container);
        document.body.appendChild(shadow);
      
        const computedStyle = getComputedStyle(markdownRef.current);
        const stylesToCopy = [
            "font-family",
            "font-size",
            "font-weight",
            "line-height",
            "color",
            "background-color",
        ];
      
        stylesToCopy.forEach((style) => {
            container.style[style] = computedStyle[style];
        });
      
        const result = shadow.innerHTML;
        document.body.removeChild(shadow);
        selection.removeAllRanges();
      
        const data = [
            new ClipboardItem({
                "text/html": new Blob([result], { type: "text/html" }),
            }),
        ];
        
        if(isTooltip){
            navigator.clipboard.write(data).then(
                () => {
                    setIsCopied(true);
                    setShowTooltip(true);
        
                    setTimeout(() => {
                        setIsCopied(false);
                        setShowTooltip(false);
                    }, 2000);
                },
                (err) => {
                    console.log("Oops, unable to copy");
                }
            );
        }

        return result;
    };
    
    return (
        <div className="message">
            <div className="bd-clipboard">
                <div id="tooltip250593" className="d-none">Copy to clipboard</div>
                <Button
                    ref={buttonCopyRef}
                    variant="outline-success"
                    className="copy-button border-0 icon-1-2x" // Add a class for the copy button
                    onClick={handleCopy}
                >
                    <i className={`bi ${isCopied ? 'bi-check2' : 'bi-clipboard'}`}></i>
                </Button>
                <Overlay target={buttonCopyRef.current} show={showTooltip} placement="top">
                    {(props) => (
                        <Tooltip id="overlay-copy" {...props}>
                            Copied!
                        </Tooltip>
                    )}
                </Overlay>
            </div>
            <div className="message-inner">
                <div className="message-header">
                    <span className="extra-small text-muted">{user}</span>
                    <span className="extra-small text-muted">{timestamp}</span>
                </div>
                
                <div className="message-body">
                    <div className="message-content">
                        <div className="message-text">
                            <div ref={markdownRef}>
                                <ReactMarkdown>{message.join('')}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    );
}

export default MessageSummarize;

